import { render, staticRenderFns } from "./ele-middle-bottom.vue?vue&type=template&id=0421d313&scoped=true"
import script from "./ele-middle-bottom.vue?vue&type=script&lang=js"
export * from "./ele-middle-bottom.vue?vue&type=script&lang=js"
import style0 from "./ele-middle-bottom.vue?vue&type=style&index=0&id=0421d313&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421d313",
  null
  
)

export default component.exports